import { Button, Text } from '@carnica/ui-kit';
import { IconInfinite, IconPlusRoundStroked, IconWifi2Outline } from '@carnica/graphics';
import React, { ComponentProps, useState } from 'react';
import classNames from 'classnames/bind';
import { withRenderFlag } from '@beef/react';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';

import { UnlimitedAccumulatorButtonType } from 'types/accumulators';
import { useExtendCustomEvent } from 'hooks/useCustomEvent';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

const getButtonContent = (buttonType: UnlimitedAccumulatorButtonType | null) => {
  if (
    buttonType === 'GbForDay' ||
    buttonType === 'Unlim3Available' ||
    buttonType === 'Unlim3Cooling'
  ) {
    return (
      <>
        <Text className={cn('gb-for-day-text')} size="xs" weight="medium">
          гб
        </Text>
        <div
          className={cn('infinite-icon-wrapper', {
            'infinite-icon-extention': buttonType === 'Unlim3Cooling',
          })}
        >
          <IconInfinite className={cn('infinite-icon')} size={12} />
        </div>
      </>
    );
  }

  if (buttonType === 'Tethering') {
    return (
      <>
        <IconWifi2Outline className={cn('wifi-icon')} size={20} />
        <div className={cn('infinite-tethering-icon-wrapper')}>
          <IconInfinite className={cn('infinite-icon')} size={12} />
        </div>
      </>
    );
  }

  return <IconPlusRoundStroked size={20} />;
};

export const _UnlimitedAccumulatorButton: React.FC<{
  buttonType: UnlimitedAccumulatorButtonType | null;
  handleAddClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isProfile?: boolean;
  sendClickMetric: (data: string) => void;
  userType: string;
}> = ({ handleAddClick, buttonType, sendClickMetric, userType, isProfile = false }) => {
  const [receivedText, setReceivedText] = useState<string>('');
  useExtendCustomEvent<string>('receiveText', (text) => {
    setReceivedText(text);
  });

  const isUnlim3Cooling = buttonType === 'Unlim3Cooling';
  const theme =
    isUnlim3Cooling && isProfile ? cnComponentsTheme('dark') : cnComponentsTheme('light');

  const handleUnlimAddClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    sendClickMetric(JSON.stringify({ userType, buttonType, optionSpeed: receivedText }));
    handleAddClick(e);
  };

  return (
    <Button
      className={cn('accumulator-button', theme)}
      onClick={handleUnlimAddClick}
      size="l"
      type="button"
      view={isUnlim3Cooling ? 'secondary-on-tertiary' : 'primary'}
    >
      <div className={cn('button-content-wrapper')}>{getButtonContent(buttonType)}</div>
    </Button>
  );
};

export const UnlimitedAccumulatorButton: React.FC<
  {
    shouldRender: boolean;
  } & ComponentProps<typeof _UnlimitedAccumulatorButton>
> = withRenderFlag(_UnlimitedAccumulatorButton);
